/* eslint-disable react/prop-types */
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Checkbox, Button } from 'antd';
import { FULFILLMENT_REQUIREMENTS, PRODUCT_NAME, getFulfillmentText } from '@/constants';
import request from '@api';
import { RadioPart, LightTooltip } from '@/components';
import { Typography } from '@mui/material';
import classes from './FulfillmentSetting.module.css';
import Loading from './Loading';

export default function FulfillmentSetting({ merchantId }) {
  const [confirmChecked, setConfirmChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fulfillmentValue, setFulfillmentValue] = useState();
  const navigate = useNavigate();

  const onChange = (e) => {
    setConfirmChecked(e.target.checked);
  };
  const radioOnChange = (e) => {
    setFulfillmentValue(e.target.value);
  };
  const onSubmit = async () => {
    setLoading(true);
    console.log({
      merchantId,
      bpOnboardingForm: {
        defaultOpt: 'default_on',
        fulfillType: fulfillmentValue,
        pdpBanner: 'show',
      },
    });

    try {
      const { code, message } = await request('open-platform-onboarding', {
        method: 'POST',
        body: {
          merchantId,
          bpOnboardingForm: {
            defaultOpt: 'default_on',
            fulfillType: fulfillmentValue,
            pdpBanner: 'show',
          },
        },
      });
      if (code === 0) {
        console.log('submit success');
        navigate('../feedback');
      } else {
        navigate('../error', { state: { message } });
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };
  const fulfillmentText = getFulfillmentText(PRODUCT_NAME.WORRY_FREE_PURCHASE);
  const tooltipPart = (
    <div className={classes.hover_container}>
      <Typography variant="body2" gutterBottom>
        {`This setting determines when ${PRODUCT_NAME.WORRY_FREE_PURCHASE} will be marked as “fulfilled” in your store. You have ${fulfillmentText.length} options:`}
      </Typography>

      {fulfillmentText.map((item) => (<div className={classes.hover_desc} key={item}>{item}</div>))}
    </div>
  );
  if (loading) {
    return <Loading />;
  }
  return (
    <div className={classes.fulfillment_setting}>
      <h1 className={classes.title}>Setup order fulfillment</h1>

      <div className={classes.content}>
        <div className={classes.fulfillment_title}>
          FULFILLMENT REQUIREMENTS
          <LightTooltip title={tooltipPart} placement="bottom-start">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_16870_33356)">
                <path d="M7.79175 4.95835H9.20842V6.37502H7.79175V4.95835ZM7.79175 7.79169H9.20842V12.0417H7.79175V7.79169ZM8.50008 1.41669C4.59008 1.41669 1.41675 4.59002 1.41675 8.50002C1.41675 12.41 4.59008 15.5834 8.50008 15.5834C12.4101 15.5834 15.5834 12.41 15.5834 8.50002C15.5834 4.59002 12.4101 1.41669 8.50008 1.41669ZM8.50008 14.1667C5.37633 14.1667 2.83341 11.6238 2.83341 8.50002C2.83341 5.37627 5.37633 2.83335 8.50008 2.83335C11.6238 2.83335 14.1667 5.37627 14.1667 8.50002C14.1667 11.6238 11.6238 14.1667 8.50008 14.1667Z" fill="black" />
              </g>
              <defs>
                <clipPath id="clip0_16870_33356">
                  <rect width="17" height="17" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </LightTooltip>
        </div>
        <RadioPart radioValue={fulfillmentValue} radioOnChange={(e) => radioOnChange(e, 1)} radioList={FULFILLMENT_REQUIREMENTS} />

      </div>
      <div className={classes.footer}>
        <div className={classes.confirm_check}>
          <Checkbox
            checked={confirmChecked}
            onChange={onChange}
            color="input"
            style={{ padding: '0px' }}
          />
          <span className={classes.confirm_text}>
            {'I have read and agreed to '}
            <a href="https://www.seel.com/terms/green-shipping-protection-for-merchant" className={classes.confirm_link} target="_blank" rel="noreferrer">Terms and Conditions</a>
          </span>
        </div>
        <Button
          type="primary"
          disabled={!confirmChecked || !fulfillmentValue}
          className={classes.next_button}
          onClick={onSubmit}
          loading={loading}
          htmlType="submit"
        >
          Enable now
        </Button>
      </div>

    </div>
  );
}
